import { Price, RoomClass } from '../interfaces/HotelDetails';
import { getKey } from 'utils/hotel';

interface Sup {
  desc: string;
  count: number;
  minPrice: number;
  checked: boolean;
}
export interface FilterRoomHotel {
  item?: {
    sysSupp?: string;
    sysSuppCode?: string;
  };
}

export const getRoomSupplierDesc = (
  room: { suppDesc?: any; suppCode?: string },
  hotel?: FilterRoomHotel,
) =>
  room.suppDesc || room.suppCode || hotel?.item?.sysSupp || hotel?.item?.sysSuppCode || 'unknown';

export class FilterRoom {
  name: string;
  boarding: boolean;
  accessible: boolean;
  refund: boolean;
  suppliers?: Sup[];
  meal: {
    active: string[];
    value: string[];
    options: string[];
    tooltips: string[];
  };

  constructor(rooms?: RoomClass[], hotel?: FilterRoomHotel, hotelIndex?: number) {
    const currency = sessionStorage.getItem(getKey('displayCurrencyHotels', hotelIndex)) || 'usd';
    this.name = '';
    this.boarding = false;
    this.accessible = false;
    this.refund = false;
    const mealOptions = ['BB', 'HB', 'FB', 'AI'];
    this.meal = {
      value: [],
      active: mealOptions.filter((mealCode) =>
        rooms?.some((rc) => rc.board?.basis?.code === mealCode),
      ),
      options: mealOptions,
      tooltips: [
        'filter.breakfast',
        'filter.half_board',
        'filter.full_board',
        'filter.all_inclusive',
      ],
    };

    let suppliers: Sup[] = [];

    rooms?.forEach((rc) => {
      const price = Math.round(rc.price[currency as keyof Price]);

      const rcDesc = getRoomSupplierDesc(rc, hotel);
      if (!suppliers.some((sup) => sup.desc === rcDesc)) {
        suppliers.push({
          desc: rcDesc,
          count: 1,
          minPrice: price,
          checked: false,
        });
      } else {
        const supIndex = suppliers.findIndex((sup) => sup.desc === rcDesc);
        suppliers[supIndex].count += 1;

        if (suppliers[supIndex].minPrice > price) {
          suppliers[supIndex].minPrice = price;
        }
      }
    });

    this.suppliers = suppliers;
  }
}
